import gql from 'graphql-tag';
import { FRAGMENT_BOOKING_GUARANTORS, FRAGMENT_BOOKING_LINK } from './booking';

const FRAGMENT_AMENDMENT_BOOKING = gql`
  fragment fragmentQueryAmendmentBooking on Booking {
    id
    status
    totalPrice
    rentalTaxRate
    rentalTaxRateType
    sourceBookingId
    specialRateOffered
    chargingStartDate
    chargingEndDate
    tenancyLengthOption
    bookingLink {
      ...fragmentBookingLink
    }
    nominationPlan {
      id
      studentPayTo
    }
    bookingSpecialOffers {
      id
      specialOfferId
      specialOfferName
    }
    latestAmendmentDetail {
      sourceBookingId
      targetBookingId
      type
      amendmentTypes
      status
      checkedIn
      installmentName {
        source
        target
      }
      tenancyEndDate {
        source
        target
      }
      pricePerNightOriginal {
        source
        target
      }
      totalPriceOriginal {
        source
        target
      }
      totalPriceAfterTax {
        source
        target
      }
      pricePerNight {
        source
        target
      }
      totalPrice {
        source
        target
      }
      taxAmount {
        source
        target
      }
      discountAmount {
        source
        target
      }
      amendmentMilestone
    }
    sourceAmendmentDetails {
      note
      status
    }
    amendmentDetails {
      targetBookingId
      sourceBookingId
      type
      status
      checkedIn
      amendmentTypes
      note
      tenancyEndDate {
        source
        target
      }
      pricePerNightOriginal {
        source
        target
      }
      totalPriceOriginal {
        source
        target
      }
      totalPriceAfterTax {
        source
        target
      }
      pricePerNight {
        source
        target
      }
      totalPrice {
        source
        target
      }
    }
    sourceBooking {
      id
      totalPrice
      bookingSpecialOffers {
        id
        specialOfferId
        specialOfferName
      }
      bookingAdditionalFees {
        additionalFeeCardConfigId
        name
        dueDate
        dueAmount
        installmentIndex
        installmentNumber
        feature
        paymentItem {
          status
          paidAmount
        }
      }
      serviceSelections {
        id
        serviceId
        serviceOptionId
        serviceName
        serviceType
        serviceOptionName
        incrementPerNight
      }
      tenancyOption {
        tenancyOptionId
        name
        startDate
        endDate
        length
      }
      roomAllocation {
        bedId
        bedName
        flatName
        roomName
        floorName
        buildingName
      }
      roomType {
        roomTypeId
        name
      }
      installment {
        installmentId
        installmentType
        name
      }
      installmentPlans {
        id
        name
        dueDate
        amountDue
        isDueBeforeBookingConfirmed
        partOfRentAdditionalFeeDeduct
        partOfRentAdditionalFees {
          name
          amount
          paymentItem {
            paidAmount
          }
        }
        paymentItem {
          id
          currency
          paidAmount
          totalAmount
          status
        }
      }
      checkOutCartInfo {
        totalAmountToBePaid
        paymentDueNow {
          amountDue
          details {
            name
            amount
            description
          }
        }
        paymentToDate
      }
    }
    targetBookings {
      id
    }
    editable
    tenancyOption {
      tenancyOptionId
      name
      startDate
      endDate
      length
    }
    tenancyOptionRateType
    roomAllocation {
      bedId
      bedName
      flatName
      roomName
      floorName
      buildingName
    }
    roomType {
      roomTypeId
      name
    }
    property {
      id
      name
      imageName
      currency
      areaUnitOfMeasurement
      contactEmailAddress
      contactAreaCode
      contactPhoneNumber
      managementCompanyName
      city {
        id
        name
        slug
      }
      country {
        id
        name
      }
      ownerName
      paymentSettings {
        paymentChannel
        paymentMethod
        isEnabled
      }
    }
    student {
      id
      email
      account {
        id
      }
    }
    installment {
      installmentId
      installmentType
      name
    }
    installmentPlans {
      id
      name
      dueDate
      amountDue
      isDueBeforeBookingConfirmed
      partOfRentAdditionalFeeDeduct
      partOfRentAdditionalFees {
        name
        amount
        paymentItem {
          paidAmount
        }
      }
      paymentItem {
        id
        currency
        paidAmount
        totalAmount
        status
      }
    }
    bookingAdditionalFees {
      additionalFeeCardConfigId
      name
      dueDate
      dueAmount
      installmentIndex
      installmentNumber
      feature
      paymentItem {
        status
        paidAmount
      }
    }
    academicYear {
      id
      name
    }
    balanceInfo {
      walletBalance
      amendmentCreditBalance
    }
    checkOutCartInfo {
      totalAmountToBePaid
      paymentDueNow {
        amountDue
        details {
          name
          amount
          description
        }
      }
      bookingTotalFeeDetail {
        rent {
          tenancyLength
          amountAfterTax
          originalAmount
          taxInfo {
            taxRate
            amount
            includedInPrice
          }
        }
        services {
          name
          amountAfterTax
          originalAmount
          taxInfo {
            taxRate
            amount
            includedInPrice
          }
        }
        additionalFees {
          name
          amountAfterTax
          originalAmount
          taxInfo {
            taxRate
            amount
            includedInPrice
          }
        }
        specialOffer {
          name
          amount
        }
        refundableFees {
          name
          amount
        }
        totalFee
      }
      paymentToDate
    }
    category
    heldToTime
    countDown
    totalPriceOriginal
    totalPriceAfterTax
    checkInDate
    checkOutDate
    contracts {
      id
      name
      content
      contractStage
      status
    }
    invoicedPaymentItems {
      id
      modelType
      category
      description
      currency
      paidAmount
      totalAmount
      status
      invoiceDatetime
      isDueBeforeBookingConfirmed
      chargeCreated
    }
    serviceSelections {
      id
      serviceId
      serviceOptionId
      serviceName
      serviceType
      serviceOptionName
      description
      incrementPerNight
    }
    paymentItems {
      id
      name
      status
    }
    documents {
      id
      name
      status
      stage
      fileUuid
      category
      guarantorId
      mandatory
      description
      rejectedReason
    }
    guarantorSettings {
      id
      academicYearId
      guarantorType
      guarantorTypeLabelName
      guarantorTypeDescription
    }
    currentGuarantorSetting {
      id
      academicYearId
      guarantorType
      guarantorTypeLabelName
      guarantorTypeDescription
    }
    curationTicket {
      id
      status
    }
    guarantors {
      ...fragmentQueryBookingGuarantors
    }
  }
  ${FRAGMENT_BOOKING_LINK}
  ${FRAGMENT_BOOKING_GUARANTORS}
`;

//can not use fragment FRAGMENT_AMENDMENT_BOOKING, because it has 'SP_GetBookingInfoAfterAmendment' exceeds maximum operation depth of 7"
const FRAGMENT_AMENDMENT_BOOKING_INFO = gql`
  fragment fragmentQueryAmendmentBookingInfo on Booking {
    id
    status
    totalPrice
    rentalTaxRate
    rentalTaxRateType
    sourceBookingId
    specialRateOffered
    documents {
      id
      name
      status
      stage
      fileUuid
      category
      guarantorId
      mandatory
      description
      rejectedReason
    }
    guarantorSettings {
      id
      academicYearId
      guarantorType
      guarantorTypeLabelName
      guarantorTypeDescription
    }
    currentGuarantorSetting {
      id
      academicYearId
      guarantorType
      guarantorTypeLabelName
      guarantorTypeDescription
    }
    curationTicket {
      id
      status
    }
    guarantors {
      ...fragmentQueryBookingGuarantors
    }
    nominationPlan {
      id
      studentPayTo
    }
    bookingSpecialOffers {
      id
      specialOfferId
      specialOfferName
    }
    latestAmendmentDetail {
      sourceBookingId
      targetBookingId
      type
      amendmentTypes
      status
      checkedIn
      installmentName {
        source
        target
      }
      tenancyEndDate {
        source
        target
      }
      pricePerNightOriginal {
        source
        target
      }
      totalPriceOriginal {
        source
        target
      }
      totalPriceAfterTax {
        source
        target
      }
      pricePerNight {
        source
        target
      }
      totalPrice {
        source
        target
      }
      taxAmount {
        source
        target
      }
      discountAmount {
        source
        target
      }
      amendmentMilestone
    }
    amendmentDetails {
      targetBookingId
      sourceBookingId
      type
      status
      checkedIn
      amendmentTypes
      tenancyEndDate {
        source
        target
      }
      pricePerNightOriginal {
        source
        target
      }
      totalPriceOriginal {
        source
        target
      }
      totalPriceAfterTax {
        source
        target
      }
      pricePerNight {
        source
        target
      }
      totalPrice {
        source
        target
      }
    }
    sourceBooking {
      id
      bookingSpecialOffers {
        id
        specialOfferId
        specialOfferName
      }
      bookingAdditionalFees {
        additionalFeeCardConfigId
        name
        dueDate
        dueAmount
        installmentIndex
        installmentNumber
        feature
        paymentItem {
          status
          paidAmount
        }
      }
      serviceSelections {
        id
        serviceId
        serviceOptionId
        serviceName
        serviceType
        serviceOptionName
        incrementPerNight
      }
      tenancyOption {
        tenancyOptionId
        name
        startDate
        endDate
        length
      }
      roomAllocation {
        bedId
        bedName
        flatName
        roomName
        floorName
        buildingName
      }
      roomType {
        roomTypeId
        name
      }
      installment {
        installmentId
        installmentType
        name
      }
      installmentPlans {
        id
        name
        dueDate
        amountDue
        isDueBeforeBookingConfirmed
        partOfRentAdditionalFeeDeduct
        partOfRentAdditionalFees {
          name
          amount
          paymentItem {
            paidAmount
          }
        }
        paymentItem {
          id
          currency
          paidAmount
          totalAmount
          status
        }
      }
      checkOutCartInfo {
        totalAmountToBePaid
        paymentDueNow {
          amountDue
          details {
            name
            amount
            description
          }
        }
        paymentToDate
      }
    }
    targetBookings {
      id
    }
    editable
    tenancyOption {
      tenancyOptionId
      name
      startDate
      endDate
      length
    }
    roomAllocation {
      bedId
      bedName
      flatName
      roomName
      floorName
      buildingName
    }
    roomType {
      roomTypeId
      name
    }
    property {
      id
      name
      imageName
      currency
      areaUnitOfMeasurement
      contactEmailAddress
      contactAreaCode
      contactPhoneNumber
      city {
        id
        name
        slug
      }
      country {
        id
        name
      }
      ownerName
      paymentSettings {
        paymentChannel
        paymentMethod
        isEnabled
      }
    }
    student {
      id
      email
      account {
        id
      }
    }
    installment {
      installmentId
      installmentType
      name
    }
    installmentPlans {
      id
      name
      dueDate
      amountDue
      isDueBeforeBookingConfirmed
      partOfRentAdditionalFeeDeduct
      partOfRentAdditionalFees {
        name
        amount
        paymentItem {
          paidAmount
        }
      }
      paymentItem {
        id
        currency
        paidAmount
        totalAmount
        status
      }
    }
    bookingAdditionalFees {
      additionalFeeCardConfigId
      name
      dueDate
      dueAmount
      installmentIndex
      installmentNumber
      feature
      paymentItem {
        status
        paidAmount
      }
    }
    academicYear {
      id
      name
    }
    balanceInfo {
      walletBalance
      amendmentCreditBalance
    }
    checkOutCartInfo {
      totalAmountToBePaid
      paymentDueNow {
        amountDue
        details {
          name
          amount
          description
        }
      }
      bookingTotalFeeDetail {
        rent {
          tenancyLength
          amountAfterTax
          originalAmount
          taxInfo {
            taxRate
            amount
            includedInPrice
          }
        }
        services {
          name
          amountAfterTax
          originalAmount
          taxInfo {
            taxRate
            amount
            includedInPrice
          }
        }
        additionalFees {
          name
          amountAfterTax
          originalAmount
          taxInfo {
            taxRate
            amount
            includedInPrice
          }
        }
        specialOffer {
          name
          amount
        }
        refundableFees {
          name
          amount
        }
        totalFee
      }
      paymentToDate
    }
    category
    heldToTime
    countDown
    totalPriceOriginal
    totalPriceAfterTax
    checkInDate
    checkOutDate
    contracts {
      id
      name
      content
      contractStage
      status
    }
    invoicedPaymentItems {
      id
      modelType
      category
      description
      currency
      paidAmount
      totalAmount
      status
      invoiceDatetime
      isDueBeforeBookingConfirmed
      chargeCreated
    }
    serviceSelections {
      id
      serviceId
      serviceOptionId
      serviceName
      serviceType
      serviceOptionName
      description
      incrementPerNight
    }
    paymentItems {
      id
      name
      status
    }
  }
  ${FRAGMENT_BOOKING_GUARANTORS}
`;

export const QUERUY_AMENDMENT_GET_BOOKING = gql`
  query SP_AmendmentGetBooking($id: ID!) {
    studentGetBooking(id: $id) {
      ...fragmentQueryAmendmentBooking
    }
  }
  ${FRAGMENT_AMENDMENT_BOOKING}
`;

export const QUERUY_GET_BOOKING_INFO_AFTER_AMENDMENT = gql`
  query SP_GetBookingInfoAfterAmendment($propertyId: ID!, $bookingId: ID!) {
    getBookingInfoAfterAmendment(propertyId: $propertyId, bookingId: $bookingId) {
      sourceBooking {
        ...fragmentQueryAmendmentBookingInfo
      }
      targetBooking {
        ...fragmentQueryAmendmentBookingInfo
      }
    }
  }
  ${FRAGMENT_AMENDMENT_BOOKING_INFO}
`;

export const MUTATION_STUDENT_UPDATE_BOOKING_GUARANTOR = gql`
  mutation SP_MutationStudentUpdateBookingGuarantor($input: studentUpsertBookingGuarantorInput!) {
    studentUpsertBookingGuarantor(input: $input) {
      id
    }
  }
`;

export const MUTATION_CONFIRM_AMENDMENT_BY_REPLACEMENT = gql`
  mutation SP_MutationConfirmAmendmentByReplacement($bookingId: ID!) {
    confirmAmendmentByReplacement(bookingId: $bookingId) {
      id
    }
  }
`;
